import React, { useEffect, useState } from "react";
import style from "css/device.module.css";

function Warranty() {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 767);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 767);

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  return (
    <div className={style.device_warranty_wrap}>
      <div className={style.device_warranty_title}>Warranty</div>
      <div className={style.device_warranty_list}>
        <div className={style.device_warranty_box}>
          <div className={style.device_warranty_icon_wrap}>
            <img
              src={
                `${process.env.REACT_APP_CLIENT_URL}` +
                `img/device/neat/clock${isMobile ? "_m" : ""}.webp`
              }
              alt="clock"
            />
          </div>
          <div className={style.device_warranty_contents_wrap}>
            <div className={style.device_warranty_label}>
              제품 구매 시, <span>1년 무상 Warranty 포함</span>
            </div>
            <div className={style.device_warranty_text}>
              {
                "제품 구매 시, 구매일로부터 1년 동안 무상 보증 서비스를 제공합니다.\n이 기간 동안 발생하는 제품 결함이나 제조상의 문제에 대해 무상으로 수리 또는 교체 서비스를 받을 수 있습니다."
              }
            </div>
          </div>
        </div>

        <div className={style.device_warranty_box}>
          <div className={style.device_warranty_icon_wrap}>
            <img
              src={
                `${process.env.REACT_APP_CLIENT_URL}` +
                `img/device/neat/verified${isMobile ? "_m" : ""}.webp`
              }
              alt="verified"
            />
          </div>
          <div className={style.device_warranty_contents_wrap}>
            <div className={style.device_warranty_label}>
              제품 이상이 있을 시, <span>제품 1:1 교환</span>
            </div>
            <div className={style.device_warranty_text}>
              제품에 이상이 있을 경우, 동일한 모델의 제품으로 1:1 교환이
              가능합니다. 제품이 정상적으로 작동하지 않거나, 예기치 않은 결함이
              발견될 경우 고객의 불편을 최소화하기 위해 신속한 교환 서비스를
              제공합니다.
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Warranty;
